import { Typography } from 'shared/ui/Typography'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { COLLECT_FIELDS_OPTIONS } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/instructionsWidgetStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'

type IInstructionsStep1Props = {
  focusedIndex: number
  onSelect: (index: number) => void
}

export const InstructionsStep1 = ({ focusedIndex, onSelect }: IInstructionsStep1Props) => (
  <div className={styles.list}>
    {COLLECT_FIELDS_OPTIONS.map((option, index) => (
      <WidgetItem
        key={option.id}
        isFocused={index === focusedIndex}
        badgeIndex={index}
        onClick={() => onSelect(index)}
      >
        <Typography variant={'body-rg-regular'} ariaLabel={option.label}>
          {option.label}
        </Typography>
      </WidgetItem>
    ))}
  </div>
)
